import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Error from '@components/form/error';

export default function Checkbox({
  label,
  error,
  field,
  name,
  className,
  checked,
  onChange,
}) {
  const classes = useMemo(() => classNames(
    'checkbox-field',
    className,
    { error },
    { checked: field?.checked || checked },
  ), [field?.checked, error, className, checked]);

  return (
    <div className={classes}>
      <label>
        <input
          name={name}
          type='checkbox'
          checked={field?.checked || checked}
          {...field}
          onChange={onChange || field?.onChange}
        />
        <i className='icon--check' />
        <div className='checkbox-field__label'>{label}</div>
      </label>
      {field && <Error name={field?.name || name} />}
    </div>
  );
}

Checkbox.defaultProps = {
  checked: false,
  error: false,
  field: null,
  onChange: null,
  className: '',
};

Checkbox.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string,
  error: PropTypes.bool,
  field: PropTypes.object,
  onChange: PropTypes.func,
};
